import { observer } from 'mobx-react-lite'
import React, { FormEvent, useEffect } from "react"
import { Col, Divider, Row } from "antd"
import { ShoppingOutlined, DollarOutlined, CarOutlined } from '@ant-design/icons'
import { Titles } from "../../../../layouts/Titles";
import i from "../../../../translations/i";
import { Options } from '../../../../components/options/Options'
import OptionTypesController from "../../../../components/options/optionTypes.controller";
import OptionValuesController from "../../../../components/options/optionValues.controller";
import projectController from "../../project/project.controller";
import { WarehouseSplitSection } from "./WarehouseSplitSection";
import { SectionBadge } from "../../../../components/SectionCard";

const GRADIENT_NEUTRAL = 'linear-gradient(135deg, #3f3d56, #63607f)'
const GRADIENT_PRIMARY = 'linear-gradient(135deg, var(--primary-color), #9186e0)'
const GRADIENT_ACCENT = 'linear-gradient(135deg, #0f9b8e, #38ada9)'

export const SplitPaymentOptionList = observer(() => {

  useEffect(() => {
    projectController.get()

    OptionTypesController.get(['splitPayments'])
      .then((keys: string[]) => OptionValuesController.get(keys))
  }, [])

  const buttons = [
    { title: i.t('def:actions.save'), htmlType: `submit`, type: 'primary' }
  ]

  const warehousesEnabled = !!projectController.project.warehouses_enabled
  const ready = OptionTypesController.render && OptionValuesController.render

  return(
    <>
      <form onSubmit={(e: FormEvent) => OptionValuesController.save(e)}>
        <Titles
          title={i.t('paymentOptions:splitPayments')}
          buttons={buttons}
        />

        <Divider />

        {ready &&
          <Row gutter={[20, 20]}>
            <Col span={24}>
              <Options types={OptionTypesController.items} options={OptionValuesController.items} renderTypes={['splitPaymentsEnabled']} />
            </Col>

            <Col span={24} xl={12}>
              <div className="order__block" style={{ width: '100%', height: 'auto', alignSelf: 'flex-start' }}>
                <SectionBadge icon={<DollarOutlined />} text={i.t('paymentOptions:serviceFee')} background={GRADIENT_PRIMARY} />
                <div style={{ display: 'flex', flexDirection: 'column', gap: 16, width: '100%' }}>
                  <Options types={OptionTypesController.items} options={OptionValuesController.items} renderTypes={['serviceFeeSplitGlobal']} />

                  {warehousesEnabled &&
                    <>
                      <Divider dashed style={{ margin: 0 }} />
                      <WarehouseSplitSection context="service_fee" />
                    </>
                  }
                </div>
              </div>
            </Col>

            <Col span={24} xl={12}>
              <div className="order__block" style={{ width: '100%', height: 'auto', alignSelf: 'flex-start' }}>
                <SectionBadge icon={<CarOutlined />} text={i.t('delivery:typeDelivery')} background={GRADIENT_ACCENT} />
                <div style={{ display: 'flex', flexDirection: 'column', gap: 16, width: '100%' }}>
                  <Options types={OptionTypesController.items} options={OptionValuesController.items} renderTypes={['deliverySplitGlobal']} />

                  {warehousesEnabled &&
                    <>
                      <Divider dashed style={{ margin: 0 }} />
                      <WarehouseSplitSection context="delivery" />
                    </>
                  }
                </div>
              </div>
            </Col>

            <Col span={24} xl={12}>
              <div className="order__block" style={{ width: '100%', height: 'auto', alignSelf: 'flex-start' }}>
                <SectionBadge icon={<ShoppingOutlined />} text={i.t('nav:products')} background={GRADIENT_NEUTRAL} />
                <div style={{ display: 'flex', flexDirection: 'column', gap: 16, width: '100%' }}>
                  <Options types={OptionTypesController.items} options={OptionValuesController.items} renderTypes={['productsSplitGlobal']} />
                </div>
              </div>
            </Col>
          </Row>
        }
      </form>
    </>
  )
})
